<template>
    <div class="p-3 row justify-content-center">
        <el-card class="col-12" :header="company.id ? company.name:'Procurando Empresa'">
            <el-skeleton :loading="loading" animated :rows="12">
                <template #default>
                    <el-form :disabled="saving" v-if="company" :model="company" label-position="top" :rules="rules" ref="formRef">
                        <el-row :gutter="30">
                            <el-col :sm="24" :md="12" :lg="10">
                                <el-form-item label="Nome da empresa" prop="name">
                                    <el-input name="name" v-model="company.name" />
                                </el-form-item>
                                <el-form-item label="Numero de telfone" prop="number">
                                    <el-input name="number" v-model="company.phone" />
                                </el-form-item>
                                <el-form-item label="Senha da empresa" prop="password">
                                    <el-input name="password" v-model="company.password" />
                                </el-form-item>
                                <el-form-item label="Descricao da empresa" prop="description">
                                    <el-input type="textarea" name="description" v-model="company.description" />
                                </el-form-item>

                                <el-form-item label="Cadastrado">
                                    Por&emsp;<b>{{ company.user?.name }}</b>, em&emsp;<b> {{ company.created_at ? new Date(company.created_at).toLocaleString():'-' }}</b>
                                </el-form-item>
                            </el-col>
                            <el-col :sm="24" :md="12" :lg="14">
                                <el-form-item label="Local" prop="area.name" v-if="company.area">
                                    <el-input name="area" v-model="company.area.name" />
                                </el-form-item>
                                <div style="height: 400px; width: 100%" class="position-relative">
                                    <el-button plain class="position-absolute end-0" style="z-index: 1024;" :loading="locating || loading" size="large" type="success" @click.prevent="locate">
                                        Localizar-me
                                    </el-button>
                                    <LMap @contextmenu="onMapClick" ref="map" v-if="company.area" :zoom="16" :center="[company.area.lat, company.area.long]">
                                        <LTileLayer
                                            url="http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}&s=Ga"
                                            layer-type="base"
                                            name="OpenStreetMap"
                                        ></LTileLayer>

                                        <LMarker v-if="company.area" :lat-lng="[company.area.lat, company.area.long]">
                                            <LTooltip>{{ company.name }}</LTooltip>
                                        </LMarker>
                                    </LMap>
                                </div>
                                <ElFormItem label="Logotipo" prop="image">
                                    <img style="max-height: 250px; max-width: 100%;" :src="(company.image as string)" />
                                    <input type="file" name="image" @change="changeFile" />
                                </ElFormItem>
                            </el-col>
                        </el-row>
                    </el-form>
                    <el-row justify="space-between" class="py-4">
                        <el-col class="col-auto">
                            <el-button type="primary" @click="submit(formRef)" plain :loading="saving">
                                Salvar alterações
                            </el-button>
                        </el-col>
                        <el-col class="col-auto">
                            <el-button type="warning" @click="showTravels = true" plain :loading="saving">
                                Marcar Viagens
                            </el-button>
                        </el-col>
                    </el-row>
                    <ElRow>
                        <ElCol :sx="24" :md="12" class="p-4">
                            <h4>Carros</h4>
                            <PersonalTable :loading="loading" :height="450" :showRows="10" :cols="[
                                {label: '#', prop: 'id'},
                                {label: 'Referencia', prop: 'reference'},
                                {label: 'Nome', prop: 'name'},
                                {label: 'Placa', prop: 'plate'},
                            ]" :data="cars" >
                            </PersonalTable>

                            <ElButton plain type="primary" @click="showModal1 = true">
                                Adicionar Carro
                            </ElButton>
                        </ElCol>
                        <ElCol :sx="24" :md="12" class="p-4">
                            <h4>Preços</h4>
                            <PersonalTable :loading="loading" :height="450" :showRows="10" :cols="[
                                {label: '#', prop: 'id'},
                            ]" :data="company.segments" >
                                <el-table-column label="Trecho" class-name="auto" :min-width="150">
                                    <template #default="data">
                                        {{ data.row.from.name }} - {{ data.row.to.name }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="Preço" class-name="auto" :min-width="150">
                                    <template #default="data">
                                        {{ data.row.pivot.price }} MT
                                    </template>
                                </el-table-column>
                            </PersonalTable>
                            <ElButton plain type="primary" @click="showModal2 = true">
                                Definir pre&ccedil;o
                            </ElButton>
                        </ElCol>
                    </ElRow>
                </template>
            </el-skeleton>
        </el-card>

        <ElDialog v-model="showModal1" :title="'Cadastrar carro'">
            <CreateCar @close="update" :travel_company_id="(company.id as number)" />
        </ElDialog>
        <ElDialog v-model="showModal2" :title="'Definir preço de viagem'">
            <CreateTravelPrice @close="update" :travel_company_id="(company.id as number)" :segments="segments" />
        </ElDialog>
        <ElDialog v-model="showTravels" :title="'Marcar viagens e publicar'" class="col-11 col-md-10 col-lg-5">
            <CreateTravel @close="showTravels = false" :travel_company_id="(company.id as number)" :cars="cars" :routes="routes" />
        </ElDialog>
    </div>
</template>

<script setup lang="ts">
    import Api from '@/services/api';
    import { Car, Event, Segment, TravelCompany, Route } from '@/services/types';
    import { ElButton, ElDialog, ElMessage, ElRow, FormInstance, FormRules, ElCol, ElInput, ElFormItem } from 'element-plus';
    import { onBeforeMount, reactive, ref } from 'vue';
    import { useRoute } from 'vue-router';
    import "leaflet/dist/leaflet.css";
    import { LMap, LTileLayer, LMarker, LTooltip} from "@vue-leaflet/vue-leaflet"
    import { LeafletMouseEvent } from 'leaflet'
    import { toFormData } from '@/utilities/helpers';
    import PersonalTable from '@/components/PersonalTable.vue';
    import CreateCar from '@/components/modals/creates/CreateCar.vue';
    import CreateTravelPrice from '@/components/modals/creates/CreateTravelPrice.vue';
    import CreateTravel from '@/components/modals/creates/CreateTravel.vue';

    type TripSegment = Segment & {
        pivot: {
            price: number
            created_at?: string | Date
        }
    }

    const route = useRoute()
    const id = route.params.id

    const loading = ref<boolean>(true)
    const saving = ref<boolean>(false)
    const locating = ref<boolean>(false)

    const formRef = ref<FormInstance>()
    const image = ref<File | null>(null)
    const apiImage = ref<string>()
    const showModal1 = ref<boolean>(false)
    const showModal2 = ref<boolean>(false)
    const showTravels = ref<boolean>(false)
    const cars = ref<Array<Car>>([])
    const segments = ref<Array<TripSegment>>([])
    const routes = ref<Array<Route>>([])
    
    const company = reactive<TravelCompany>({
        description: '',
        image: null,
        name: '',
        area: {lat: 0, long: 0, name: ''},
        id: 0,
        user: undefined,
        segments: [],
        phone: null,
        password: null
    })

    const getImageUrl = (image: string) => `${Api.publicUrl}alt-storage?path=travel_companies/${image}`

    const rules = ref<FormRules<Event>>({
        name: [{required: true, message: 'Preencha este campo'}],
        description: [{required: true, message: 'Preencha este campo'}],
        "area.name": [{required: true, message: 'Preencha este campo'}],
    })

    const changeFile = ({target: {files}}: any) => {
        console.log(files)
        if (files[0]) {
            image.value = files[0]
            company.image = URL.createObjectURL(files[0])
        } else {
            image.value = null
            company.image = (apiImage.value as string)
        }
    }

    const getSegments = async () => {
        const res = await Api.get(`admin/trip-segments`)
        if (res.status == 200) {
            segments.value = res.data.segments
        } else {
            console.log(res)
            ElMessage.error(res.data.message)
        }
    }

    const getRoutes = async () => {
        const res = await Api.get(`admin/routes`)
        if (res.status == 200) {
            routes.value = res.data.routes
        } else {
            console.log(res)
            ElMessage.error(res.data.message)
        }
    }

    const getCompany = async (id: number | string) => {
        const res = await Api.get(`admin/travel-companies/${id}`)

        if (res.status == 200) {
            const data = res.data.company
    
            company.id = data.id
            company.area = data.area
            company.user = data.user
            company.name = data.name
            company.phone = data.phone
            company.description = data.description
            company.created_at = data.created_at
            company.segments = data.trip_segments
            cars.value = data.cars

            apiImage.value = getImageUrl(data.image)
            company.image = apiImage.value
            console.log(data)
        } else {
            console.log(res)
            ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
        }
    }

    const onMapClick = (mouseEvent: LeafletMouseEvent) => {
        const { lat, lng } = mouseEvent.latlng
        if (company.area) {
            company.area.lat = lat
            company.area.long = lng
        } else {
            company.area = {
                name: '',
                lat,
                long: lng
            }
        }
        console.log(company.area);
    }

    const update = () => {
        loading.value = true
        getCompany(id as string).finally(() => {
            loading.value = false
            showModal1.value = false
            showModal2.value = false
        })
    }

    const locate = async () => {
        locating.value = true

        if (!navigator.geolocation) {
            alert("Geolocalização não é suportada pelo seu navegador.")
            locating.value = false
            return
        }

        navigator.geolocation.getCurrentPosition((position) => {
            if (company.area) {
                company.area.lat = position.coords.latitude
                company.area.long = position.coords.longitude
            }
            locating.value = false
        }, (err) => {
            console.log(err)
            alert("Ocorreu um erro ao tentar localizar")
            locating.value = false
        })
    }

    const submit = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        if (!company.area?.lat || !company.area.long) {
            ElMessage.error({message: 'Por favor selecione o local no mapa'})
            return null
        }
        await formEl.validate(async (valid) => {
            if (valid) {
                saving.value = true
                const formData = toFormData(company)
                if (image.value) {
                    formData.append("image", image.value)
                } else {
                    formData.delete("image")
                }
                if (!company.phone || (company.phone as string).length < 1) {
                    formData.delete('phone')
                }
                if (!company.password || (company.password as string).length < 1) {
                    formData.delete('password')
                }
                const res = await Api.post('/admin/travel-companies/' + company.id, company, formData)
                if (res.status == 200) {
                    ElMessage.success({message: 'Atualizado com sucesso'})
                    await getCompany(id as string)
                } else {
                    console.log(res)
                    ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
                }
                saving.value = false
            }
        })
    }

    onBeforeMount(async () => {
        loading.value = true
        await Promise.all([
            getCompany(id as string),
            getSegments(),
            getRoutes()
        ])
        loading.value = false
    })
</script>

<style lang="scss" scoped>
    table.list-tickets {
        width: 100% !important;
    }
    table.list-tickets td {
        padding-top: 10px;
        padding-bottom: 10px;
    }
    table.list-tickets tr {
        border-bottom: 1px solid gray;
    }
</style>